
export const ConfirmationDialogText = {
    "delete_tag": { title: "Please confirm", body: "Do you really want to delete this tag?", okButtonText: "Delete", cancelButtonText: "Cancel" },
    "delete_tags": { title: "Please confirm", body: "Do you really want to delete these tags?", okButtonText: "Delete", cancelButtonText: "Cancel" },
}

/**
 * How a tag form should treat `Group_Tour_Tag.custom_id` ("External ID").
 *
 * The field is only meaningful on a category that declares `external_identity`:
 * there the id -- not the name -- is the tag's identity, which is why two tags in
 * such a category may share a display name. `/v2/edit` REFUSES a custom_id on any
 * other category, so the field has to be absent rather than rendered-and-disabled.
 *
 * The third case is the one that bites in practice. Turning the flag back off
 * leaves existing rows carrying an id the category no longer honours; hiding the
 * field must not hide that value, or it silently survives every save.
 *
 *   'field'    -- render the editable External ID input
 *   'stranded' -- the category identifies by name, but this tag still has an id
 *   'none'     -- nothing to show
 *
 * A category payload with no `external_identity` key (an older cached response, or
 * a nested brief that predates the field) reads as name-identified, which is both
 * the old behaviour and the safe default for a flag that only unlocks a field.
 */
export const identityFieldMode = (tag) => {
    if (tag?.category?.external_identity) return 'field';
    if (tag?.custom_id) return 'stranded';
    return 'none';
};
